import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class CloseRequestPayload extends RequestPayload {
}



// WEBPACK FOOTER //
// ./~/slotworks/model/gameplay/requests/close-request-payload.ts